import React from 'react';
import { ArrowRight, Check, Phone } from 'lucide-react';
import './Hero.css';

const highlights = [
    'Gratis prototyp – betala först när du är nöjd',
    'Personlig kontakt genom hela projektet',
    'Baserade i Falun, verksamma i hela Sverige',
];

export default function Hero() {
    return (
        <section className="hero">
            <div className="container hero-content">
                <div className="hero-text fade-up">
                    <span className="hero-eyebrow">Webbyrå i Falun</span>
                    <h1 className="hero-title">
                        Se din nya hemsida <span className="hero-highlight">innan du betalar</span>
                    </h1>
                    <p className="hero-lead">
                        Vi bygger en gratis prototyp av din hemsida så att du ser exakt
                        vad du får. Du betalar först när du är nöjd.
                    </p>
                    <div className="hero-cta">
                        <a href="#contact" className="btn-primary">
                            Få en gratis prototyp <ArrowRight size={18} />
                        </a>
                        <a href="#portfolio" className="btn-secondary">
                            Se vårt arbete
                        </a>
                    </div>
                    <p className="hero-call">
                        <Phone size={15} />
                        Eller ring direkt:{' '}
                        <a href="tel:0766140446">076-614 04 46</a>
                    </p>
                    <p className="hero-trust">
                        <strong>10+</strong> lanserade projekt åt företag i Dalarna
                    </p>
                    <ul className="hero-points">
                        {highlights.map((point) => (
                            <li key={point}>
                                <Check size={16} strokeWidth={3} />
                                {point}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="hero-visual fade-up fade-up-delayed">
                    <figure className="hero-shot main">
                        <div className="hero-shot-bar">
                            <span className="hero-shot-url">svenskaprodukter.se</span>
                        </div>
                        <img
                            src="/images/portfolio/svenskaprodukter.webp"
                            alt="Hemsida vi byggt åt Svenska Produkter"
                            width="1280"
                            height="800"
                            fetchPriority="high"
                        />
                    </figure>
                    <figure className="hero-shot small">
                        <div className="hero-shot-bar">
                            <span className="hero-shot-url">sorentopizza.se</span>
                        </div>
                        <img
                            src="/images/portfolio/sorentopizza.webp"
                            alt="Hemsida vi byggt åt Sorento Pizzeria"
                            width="1280"
                            height="800"
                            loading="lazy"
                        />
                    </figure>
                    <div className="hero-badge">
                        <strong>10+</strong>
                        <span>lanserade projekt</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
